import { type } from "@/api/arktype";

import { Normalize } from "@/api/normalize/normalize";

const trimmedTitle = type("string")
	.pipe((value) => value.trim())
	.narrow(
		(value, ctx) =>
			value.length > 0 || ctx.reject({ expected: "a non-empty title", actual: "blank" }),
	);

const trimmedContent = type("string")
	.pipe((value) => value.trim())
	.narrow(
		(value, ctx) =>
			value.length > 0 || ctx.reject({ expected: "non-empty content", actual: "blank" }),
	);

export const WikiSchemas = {
	create: type({ title: trimmedTitle, content: trimmedContent })
		.narrow((input, ctx) => {
			if (Normalize.slug(input.title).length === 0) {
				return ctx.reject({ expected: "a title with slug substance", actual: input.title });
			}

			return true;
		})
		.pipe((input) => ({
			title: input.title,
			content: input.content,
			slug: Normalize.slug(input.title),
		})),

	page: type({ slug: "string" }),

	revisions: type({ slug: "string" }),

	edit: type({ slug: "string", content: trimmedContent }),
};

export type WikiCreateInput = typeof WikiSchemas.create.infer;
export type WikiEditInput = typeof WikiSchemas.edit.infer;
